import { IconPropsType } from '..';

export const ErrorCircleIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      width="12"
      height="12"
      fill="#1E1E1E"
    />
    <g id="Withdrawals - history">
      <path
        d="M-1874 -1669C-1874 -1670.1 -1873.1 -1671 -1872 -1671H724C725.104 -1671 726 -1670.1 726 -1669V527C726 528.104 725.104 529 724 529H-1872C-1873.1 529 -1874 528.104 -1874 527V-1669Z"
        fill="#404040"
      />
      <path
        d="M-1872 -1670H724V-1672H-1872V-1670ZM725 -1669V527H727V-1669H725ZM724 528H-1872V530H724V528ZM-1873 527V-1669H-1875V527H-1873ZM-1872 528C-1872.55 528 -1873 527.552 -1873 527H-1875C-1875 528.657 -1873.66 530 -1872 530V528ZM725 527C725 527.552 724.552 528 724 528V530C725.657 530 727 528.657 727 527H725ZM724 -1670C724.552 -1670 725 -1669.55 725 -1669H727C727 -1670.66 725.657 -1672 724 -1672V-1670ZM-1872 -1672C-1873.66 -1672 -1875 -1670.66 -1875 -1669H-1873C-1873 -1669.55 -1872.55 -1670 -1872 -1670V-1672Z"
        fill="white"
        fillOpacity="0.1"
      />
      <g id="col">
        <rect
          width="730"
          height="376"
          transform="translate(-133 -300)"
          fill="#262A40"
        />
        <g id="col_2">
          <g id="line">
            <mask
              id="path-3-inside-1_1392_50978"
              fill="white"
            >
              <path d="M-123 -12H587V24H-123V-12Z" />
            </mask>
            <path
              d="M587 23H-123V25H587V23Z"
              fill="#2E334D"
              mask="url(#path-3-inside-1_1392_50978)"
            />
            <g id="Frame 2015">
              <g id="kb-core-icon">
                <g id="Vector">
                  <path
                    d="M8.80002 8.01591L8.01602 8.79991L6.00002 6.78391L3.98402 8.79991L3.20002 8.01591L5.21602 5.99991L3.20002 3.98391L3.98402 3.19991L6.00002 5.21591L8.01602 3.19991L8.80002 3.98391L6.78402 5.99991L8.80002 8.01591Z"
                    fill="#C11EEA"
                  />
                  <path
                    d="M5.9999 0.399902C4.89233 0.399902 3.80963 0.728337 2.88871 1.34367C1.9678 1.95901 1.25003 2.83361 0.826179 3.85687C0.402329 4.88014 0.29143 6.00611 0.507507 7.09241C0.723585 8.1787 1.25693 9.17652 2.04011 9.9597C2.82328 10.7429 3.82111 11.2762 4.9074 11.4923C5.99369 11.7084 7.11966 11.5975 8.14293 11.1736C9.1662 10.7498 10.0408 10.032 10.6561 9.11109C11.2715 8.19018 11.5999 7.10748 11.5999 5.9999C11.5999 5.2645 11.4551 4.5363 11.1736 3.85687C10.8922 3.17745 10.4797 2.56011 9.9597 2.0401C9.43969 1.5201 8.82235 1.1076 8.14293 0.826177C7.46351 0.544751 6.73531 0.399902 5.9999 0.399902ZM5.9999 10.4799C5.11384 10.4799 4.24768 10.2172 3.51095 9.72488C2.77422 9.23262 2.2 8.53294 1.86092 7.71432C1.52184 6.89571 1.43312 5.99493 1.60599 5.1259C1.77885 4.25686 2.20553 3.4586 2.83207 2.83206C3.45861 2.20552 4.25686 1.77885 5.1259 1.60598C5.99493 1.43312 6.89571 1.52184 7.71433 1.86092C8.53294 2.2 9.23262 2.77422 9.72489 3.51095C10.2172 4.24768 10.4799 5.11384 10.4799 5.9999C10.4784 7.18762 10.0059 8.32626 9.16611 9.1661C8.32626 10.0059 7.18762 10.4784 5.9999 10.4799Z"
                    fill="#C11EEA"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
